import { useState } from 'react';
import { api } from '@/shared/api/cliente';
import { ErrorDeApi } from '@/shared/api/problema';
import { notificar } from '@/shared/ui/avisos';

interface ReciboEnPantalla {
  pagoId: number;
  comprobante: string | null;

  fichero: Blob | null;
}

export function useRecibo() {
  const [recibo, setRecibo] = useState<ReciboEnPantalla | null>(null);
  const [preparando, setPreparando] = useState<number | null>(null);

  async function abrir(pagoId: number, comprobante: string | null = null) {
    setPreparando(pagoId);
    setRecibo({ pagoId, comprobante, fichero: null });
    try {
      const fichero = await api.descargar(`/cobros/${pagoId}/recibo.pdf`);
      if (!fichero) {
        notificar.error('NO SE PUDO GENERAR EL RECIBO');
        setRecibo(null);
        return;
      }

      setRecibo((actual) => (actual?.pagoId === pagoId ? { ...actual, fichero } : actual));
    } catch (causa) {
      notificar.error(causa instanceof ErrorDeApi ? causa.message : 'NO SE PUDO ABRIR EL RECIBO');
      setRecibo(null);
    } finally {
      setPreparando(null);
    }
  }

  return {
    recibo,

    preparando,
    abrir,
    cerrar: () => setRecibo(null),
  };
}
